import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { FehlerartListView } from "./list-view/fehlerart.list-view";

export const fehlerartFieldOk: FieldOkConfig = {
  name: 'fehlerart',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{fehlerart}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: FehlerartListView
    }
  }
  ]
};
export const fehlerartMultiselectFieldOk: FieldOkConfig = {
  name: 'fehlerart',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{fehlerart}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: FehlerartListView
    }
  }
  ]
};

export const fehlerartQueryFieldOk: FieldOkConfig = {
  name: 'fehlerart',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{fehlerart}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: FehlerartListView
    }
  }
  ]
};
